var LoginPage = require('./login')

module.exports = {
  hello_world: "Hello World!",
  stores: "Stores",
  sign_in_to_your_TokoPOS_account: "Sign in to your TokoPOS account",
  remember_me: "Remember Me",
  email: "Email",
  please_enter_email: "Please Enter Valid Email",
  password: "Password",
  please_enter_password: "Please Enter the Password",
  forgot_password: "Forgot Password?",
  sign_in: "Sign In",
  dont_have_an_account_to_TokoPOS: "Don’t have account on TokoPOS?",
  registration: "Registration",
  english: "English",
  french: "French",
  create_your_free_TokoPOS_account: "Create TokoPOS account",
  login: "Login",
  already_have_an_account: "Already have an account?",
  business_name: "Business Name",
  please_enter_business_name: "Please Enter Your Business Name",
  business_type: "Business Type",
  business_entity_type: "Business Entity Type",
  select: "Select",
  please_select_business_type: "Please Select Your Business Type",
  country: "Country",
  please_select_country: "Please Select Country",
  please_agree_to_TokoPOS_terms: "Please Agree to TokoPOS Terms of Use and Privacy Policy",
  i_understand_and_agree_to_TokoPOS: "I Understand and Agree to TokoPOS",
  terms_of_use: "Terms of Use",
  and: "and",
  privacy_policy: "Privacy Policy",
  settings: "Settings",
  system_settings: "System Settings",
  store_and_pos_settings: "Store & POS Settings",
  general: "General",
  billing_and_subscriotion: "Billing & Subscriptions",
  payment_types: "Payment Types",
  taxes: "Taxes",
  receipt: "Receipt",
  kitchen_printers: "Kitchen Printers",
  dinning_options: "Product Delivery Option",
  dinning_options_store: "Product Delivery Option - Store",
  general_settings: "General Settings",
  timezone: "Timezone",
  please_select_timezone: "Please Select Timezone",
  ui_language: "UI Language",
  please_select_ui_langugae: "Please Select UI Language",
  features: "Features",
  track_crash_that_goes_in_and_out_of_your_drawer: "Track cash in and out of your drawer.",
  learn_more: "Learn More",
  time_clock: "Time Clock",
  add_payment_type: "Add Payment Type",
  name: "Name",
  type: "Type",
  action: "Action",
  are_you_sure_you_want_to_delete_payment_type: "If you delete this payment method, your store will not be able to accept online transactions. Do you want to delete it?",
  are_you_sure_you_want_to_disable_payment_type: "If you disable this payment method, your store will not be able to accept online transactions. Do you want to disable it?",
  delete_payment_type: "Delete Payment Type",
  add: "Add",
  edit: "Edit",
  receipt_setting: "Receipt Settings",
  upload: "Upload",
  header: "Header for Email Receipt",
  please_enter_header: "Please Enter the Header",
  footer: "Footer for Email Receipt",
  please_enter_footer: "Please Enter the Footer",
  show_customer_info: "Show Customer Info",
  show_comments: "Show Comments",
  receipt_language: "Receipt Language",
  dinning_option: "Dinning Option",
  add_dinning_option: "Add Product Delivery Option",
  available: "Available",
  track_employees_clock_in_out_time_and_calculate_their_total_work_hours: "Track employee in/out hours and calculate their total work hours.",
  open_tickets: "Open Tickets",
  allow_to_save_and_edit_orders_before_completing_a_payment: "Allow to save and edit orders before completing a payment.",
  send_orders_to_kitchen_printer_or_display: "Send orders to kitchen printer or display.",
  customer_displays: "Customer Displays",
  display_order_information_to_customers_at_the_time_of_purchase: "Display order information to customers at the time of purchase.",
  low_stock_notification: "Low Stock Notification",
  negative_stock_alerts: "Negative Stock Alerts",
  all_stores: "All Stores",
  add_tax: "Add Tax",
  default_dinning_option: "Default Product Delivery Option",
  default: "Default",
  pos_devices: "POS Devices",
  menu_devices: "Menu devices",
  add_store: "Add store",
  address: "Address",
  number_of_pos: "Number of POS",
  add_pos: "Add POS",
  add_menu: "Add Menu",
  menu: "Menu",
  store: "Store",
  all_status: "All Status",
  all_store: "All Store",
  all_supplier: "All Supplier",
  expected_arrival_on: "Expected Arrival Date",
  status: "Status",
  activated: "Activated",
  not_activated: "Not Activated",
  confirm_delete_pos_message: "Are you sure want to delete POS? TokoPOS app will be deactivated on the device assigned to this POS.",
  confirm_release_pos_message: "Are you sure want to release POS? TokoPOS app will be deactivated on the device assigned to this POS",
  confirm_delete_menu_message: "Are You Sure Want To Delete Menu? TokoPOS Menu app will be deactivated on the device assigned to this Menu App",
  are_you_sure_you_want_to_delete_the_review: "Are You Sure Want To Delete the Review?",
  no_reviews_found: "No Review Found",
  add_review: "Add Review",
  update_bank: "Update Review",
  delete_pos: "Delete POS",
  delete_menu: "Delete Menu",
  payment_type: "Payment Type",
  please_enter_name: "Please Enter Name",
  please_select_payment_type: "Please Select Payment Type",
  please_select_payment_name: "Please Select Payment Name",
  card: "CARD",
  cash: "CASH",
  other: "OTHER",
  save_btn_text: "Save",
  cancel_btn_text: "Cancel",
  apply_to_new_items: "Apply To the New Items",
  tax_rate: "Tax Rate",
  rate: "Rate",
  emailed_receipt: "Logo for Email Receipt",
  printed_receipt: "Logo for Printed Receipt",
  please_select_receipt_language: "Please Select the Receipt Language",
  no_paymen_type_found: "No Payment Type Found",
  use_predefined_tickets: "Use predefined tickets",
  use_predefined_tickets_text: "This feature allows you to quickly assign names to open tickets. For example, Table 1, Table 2, etc.",
  add_option: "Add option",
  please_enter_unique_option_name: "Please enter unique option name",
  add_employee: "Add Employee",
  search_enter: "Search & Enter",
  employee_name: "Employee Name",
  phone_number: "Phone Number",
  role: "Role",
  create_employee: "Create a New Employee",
  phone: "Phone",
  please_enter_10_digits_phone_number: "Please enter minimum 7 digits phone number",
  please_enter_10_digits_mobile_number: "Please enter minimum 7 digits mobile number",
  please_enter_10_digits_hand_phone: "Please enter minimum 7 digits mobile number",
  select_role: "Select Role",
  please_select_role: "Please Select the Role",
  available_in_all_stores: "Available in all stores",
  delete_employee: "Delete Employee",
  are_you_sure_you_want_to_delete_the_employee: "Are you sure want to delete the employee?",
  delete_role: "Delete Role",
  add_role: "Add Role",
  access: "Access",
  employees: "Employees",
  old_password: "Old Password",
  new_password: "New Password",
  confirm_password: "Confirm Password",
  change_password: "Change Password",
  please_enter_new_password: "Please enter new password",
  please_enter_old_password: "Please enter old password",
  please_enter_confirm_password: "Please confirm new password",
  upload_profile: "Upload Profile",
  back_office_and_pos: "Back Office and POS",
  pos: "POS",
  back_office: "Back Office",
  employees_can_log_in_to_the_app_using_personal_pin_code: "Employee can log in to the app using personal PIN code",
  view_all_receipts: "View all receipts",
  when_this_option_is_disabled_a_cashier_can_view_the_last_5_receipts: "When this option is disabled, a cashier can view the last 5 receipts",
  apply_discounts_with_restricted_access: "Apply discounts with restricted access",
  change_taxes_in_a_sale: "Change taxes in a sale",
  carry_out_purchasing_returns: "Carry out purchasing returns",
  manage_all_open_tickets: "Manage all open tickets",
  delete_saved_items_in_open_tickets: "Delete saved items in open tickets",
  view_shift_report: "View shift report",
  open_cash_drawer_without_making_a_sale: "Open cash drawer without making a sale",
  edit_items: "Manage items, categories, and discounts",
  change_settings: "Change settings",
  access_to_live_chat_support: "Access to live chat support",
  access_to_jubelio: "Access Jubelio Integration",
  edit_b2b_store: "Manage B2B Store",
  employees_can_log_in_to_the_back_office_using_their_email_and_password: "Employee can log in to Back Office using their email and password",
  employees_can_log_in_to_the_menu_app_using_their_email_and_password: "Employee can log in to Menu app using their email and password",
  view_sales_reports: "View sales report",
  reports: "Reports",
  menu_app: "Menu App",
  items_and_inventory_management: "Items and Inventory Management",
  edit_items_and_manage_inventory: "Edit Items and Manage inventory",
  manage_employees: "Manage employees",
  customers: "Customers",
  customer: "Customer",
  access_to_customer_base: "Access to customer base",
  edit_profile: "Manage General Settings and Features",
  manage_billing: "Manage billing",
  set_the_payment_types: "Manage Payment Types",
  change_settings_of_loyalty_program: "Change settings of loyalty program",
  set_the_taxes: "Set Taxes",
  set_the_kitchen_printers: "Set the kitchen printers",
  manage_dining_options: "Manage Product Delivery Options",
  manage_pos_devices: "Manage POS Devices",
  this_permission_also_allows_to_sign_into_pos_using_email_and_password: "This permission also allows signing into POS using email and password",
  support: "Support",
  add_customer: "Add Customer",
  export: "Export",
  export_receipt: "Export receipt",
  export_purchase_order: "Export Purchase Order",
  export_transaction: "Export all transactions",
  import: "Import",
  last_visit: "Last Visit",
  first_visit: "First Visit",
  total_visits: "Total Visits",
  total_spent: "Total Spent",
  create_customer: "Create Customer",
  note: "Note",
  register: "Register",
  retail: "RETAIL",
  restaurants: "RESTAURANTS",
  submit: "Submit",
  back_to: "Back to",
  tax_application_depends_on_dining_option: "Tax application depends on dining option",
  delete_dinning_option: "Delete Product Delivery Option",
  select_store: "Select Store",
  please_select_store: "Please select store",
  please_enter_address: "Please enter address",
  latitude: "Latitude",
  please_enter_latitude: "Please enter latitude",
  longitude: "Longitude",
  please_enter_longitude: "Please enter longitude",
  description: "Description",
  all_employees: "All Employees",
  clock_in_date: "Clock in date",
  clock_out_date: "Clock out date",
  clock_in_time: "Clock in time",
  clock_out_time: "Clock out date",
  total_hours: "Total Hours",
  create: "Create",
  save: "Save",
  add_timecard: "Add Timecard",
  clock_in: "Clock In",
  clock_out: "Clock Out",
  category_name: "Category Name",
  categories: "Categories",
  delete_dinning_option_message: "Are you sure want to delete the product delivery option?",
  delete_kitchen_printer_message: "Are you sure want to delete the kitchen printer?",
  delete_kitchen_printers_message: "Are you sure want to delete kitchen printers?",
  available_in: "Available in",
  store_lowercase: "store",
  categories_printed_on_this_group: "Categories printed on this printer group",
  delete_kitchen_printer: "Delete Kitchen Printer",
  deleted_successfully: "Deleted successfully!",
  restored_successfully: "Restored successfully!",
  add_categories: "Add Categories",
  add_category: "Add Category",
  create_category: "Create Category",
  value: "Value",
  max_value: "Max Value",
  restricted_access: "Restricted Access",
  variable: "variable",
  yes: "Yes",
  no: "No",
  create_discount: "Create Discount",
  percentage: "Percentage",
  fix: "Fix",
  sum: "Sum",
  leave_the_field_blank_to_indicate_the_value_upon_sale: "Leave the field blank to indicate the value upon sale",
  only_employees_with_appropriate_access_right_are_able_to_apply_this_discount: "Only employee with appropriate access rights is able to apply this discount",
  delete_discount: "Delete Discount",
  delete_discount_message: "Are you sure want to delete the discount?",
  delete_category_message: "Are you sure want to delete the category?",
  delete_modifier: "Delete Modifier",
  delete_modifier_message: "Are you sure want to delete the modifier?",
  add_modifiers: "Add Modifiers",
  no_modifier_found: "No Modifiers Found",
  no_employee_found: "No Employees Found",
  no_category_found: "No Categories Found",
  no_discount_found: "No Discounts Found",
  no_roles_found: "No Roles Found",
  no_timecard_found: "No Time Cards Found",
  no_record_found: "No Records Found",
  no_customer_found: "No Customers Found",
  modifier_name: "Modifier Name",
  option_name: "Option name",
  price: "Price",
  region_state_province: "Region/State/Province",
  select_country: "Select Country",
  please_enter_region: "Please enter region",
  postal_or_zip_code: "Postal/Zip Code",
  please_enter_zip_code: "Please enter valid Zip Code",
  city: "City",
  please_enter_address_2: "Please select Address2",
  please_enter_address_1: "Please select Address1",
  address_1: "Address 1",
  address_2: "Address 2",
  website: "Website",
  please_enter_website: "Please enter valid website",
  contact_number: "Contact Number",
  please_enter_contact_number: "Please enter valid contact number",
  supplier_name: "Supplier Name",
  please_enter_supplier_name: "Please enter the supplier name",
  please_enter_phone_number: "Please enter valid phone number",
  please_enter_mobile_number: "Please enter valid mobile number",
  please_enter_handphone_number: "Please enter valid phone number",
  select_status: "Select Status",
  select_supplier: "Select Supplier",
  puchase_order: "Purchase Order",
  date: "Date",
  supplier: "Supplier",
  expected_on: "Expected On",
  total: "Total",
  no_customers_found: "No Customers Found",
  no_stores_found: "No stores found",
  no_pos_devices_found: "No POS devices found",
  no_menu_devices_found: "No Menu devices found",
  delete_multiple_payment_types_message: "Are you sure want to delete payment types?",
  pos_pin: "POS pin",
  please_enter_4_digits_pos_pin: "Please enter 4 digits POS PIN",
  please_enter_valid_tax_rate: "Please Enter Valid Rate",
  please_select_type: "Please select type",
  included_in_the_price: "Included in the price",
  added_in_to_the_price: "Added in to the price",
  option: "Option",
  apply_the_tax_to_the_new_item: "Apply Tax to the new item",
  apply_the_tax_to_the_existing_item: "Apply Tax to the existing item",
  apply_the_tax_to_all_new_and_existing_item: "Apply Tax to all new & existing item",
  none: "None",
  please_select_option: "Please select option",
  are_you_sure_you_want_to_delete_tax: "Are you sure want to delete tax?",
  delete_multiple_taxes_message: "Are you sure want to delete selected taxes?",
  delete_tax: "Delete Tax",
  no_kitchen_printer_found: "No kitchen printers found",
  no_dinning_option_found: "No Product Delivery Option Found",
  no_taxes_found: "No taxes found",
  add_discounts: "Add Discounts",
  update_employee: "Update Employee",
  update_category: "Update Category",
  update_customer: "Update Customer",
  update_discount: "Update Discount",
  delete_multiple_customers_message: "Are you sure want to delete selected customers?",
  delete_multiple_employee_message: "Are you sure want to delete selected employee?",
  delete_customer: "Delete Customer",
  are_you_sure_you_want_to_delete_the_customer: "Are you sure want to delete the customer?",
  delete_store: "Delete Store",
  confirm_delete_store_message: "Are you sure want to delete the store?",
  add_item: "Add Item",
  print: "Print",
  item_name: "Item Name",
  category: "Category",
  cost: "Cost",
  margin: "Margin",
  in_stock: "In Stock",
  no_category: "No Category",
  select_category: "Select Category",
  stock_alert: "Stock Alert",
  low_stock: "Low Stock",
  out_stock: "Out of Stock",
  no_items_found: "No Items Found",
  delete_item: "Delete Item",
  duplicated_item_name: "Duplicated Item Name",
  duplicated_customer_data: "Duplicate Customers Data",
  restore_item: "Restore Item",
  confirm_delete_item_message: "Are you sure want to delete this item?",
  delete_multiple_items_message: "Are you sure want to delete selected items?",
  restore_multiple_items_message: "Are you sure want to restore selected items?",
  weight: "Weight",
  each: "Each",
  sold_by: "Sold By",
  please_select_category: "Please select category",
  leave_the_field_blank_to_indicate_the_price_for_sale: "Leave the field blank to indicate the price upon sale",
  please_enter_valid_price: "Please enter valid price",
  please_enter_valid_cost: "Please enter valid cost",
  sku: "SKU",
  please_enter_sku: "Please enter SKU",
  barcode: "Barcode",
  inventory: "Inventory",
  composite_item: "Composite item",
  track_stock: "Track stock",
  sku_and_barcode: "SKU and barcode",
  average_cost: "Average Cost",
  please_enter_valid_average_cost: "Please enter valid average cost",
  primary_supplier: "Primary Supplier",
  default_purchase_cost: "Default Purchase Cost",
  please_enter_default_purchase_cost: "Please eneter valid cost",
  please_select_atleast_one_item: "Please select at least one item",
  use_production: "Use production",
  add_variants: "Add Variants",
  please_enter_option_name: "Please enter option name",
  component: "Component",
  quantity: "Quantity",
  qty: "Qty",
  item_search: "Item Search",
  category_search: "Category Search",
  supplier_search: "Supplier Search",
  variants: "Variants",
  use_variants_suggestion_messge: "Use variants if an item has different sizes, colors or other options",
  variant: "Variant",
  purchase_cost: "Purchase Cost",
  representation_on_pos: "Representation on POS",
  color_and_shape: "Color and Shape",
  image: "Image",
  upload_image: "Upload Image",
  modifiers: "Modifiers",
  modifier: "Modifier",
  items: "Items",
  recently_deleted_items: "Recently Deleted Items",
  item_list: "Item List",
  discounts: "Discounts",
  cost_of_goods: "Cost of Goods",
  inventory_management: "Inventory Management",
  suppliers: "Suppliers",
  employee_list: "Employee List",
  sales_by_category: "Sales by Category",
  sales_by_employee: "Sales by Employee",
  sales_by_payment_type: "Sales by Payment Type",
  receipts: "Receipts",
  shifts: "Shifts",
  add_supplier: "Add Supplier",
  are_you_sure_you_want_to_delete_the_role: "Are you sure want to delete the role?",
  please_select_image: "Please select image",
  item_sold: "Items Sold",
  gross_sale: "Gross Sale",
  items_refunded: "Items Refunded",
  refunds: "Refunds",
  refund: "Refund",
  net_sale: "Net Sale",
  cost_of_good: "Cost of Good",
  gross_profit: "Gross Profit",
  all_day: "All Day",
  custome_period: "Custom Period",
  discount_applied: "Discounts Applied",
  amount_discounted: "Amount Discounted",
  average_sale: "Average Sale",
  customers_signed_up: "Customers Signed Up",
  payment_transactions: "Payment Transactions",
  payment_amount: "Payment Amount",
  refund_transactions: "Refund Transactions",
  refund_amount: "Refund Amount",
  net_amount: "Net Amount",
  no_receipt_found: "No Receipt Found",
  all_receipts: "All Receipts",
  sales: "Sales",
  receipt_no: "Receipt no.",
  employee: "Employee",
  amount: "Amount",
  discount: "Discount",
  no_tax_found: "No Tax Found",
  taxable_sales: "Taxable sales",
  non_taxable_sales: "Non-Taxable sales",
  total_net_sales: "Total net sales",
  tax_name: "Tax name",
  tax_amount: "Tax amount",
  no_shift_found: "No Shift Found",
  opening_time: "Opening Time",
  closing_time: "Closing Time",
  expected_cash_amount: "Expected Cash Amount",
  actual_cash_amount: "Actual Cash Amount",
  difference: "Difference",
  optimal_stock: "Optimal Stock",
  are_you_sure_you_want_to_delete_the_item: "Are you sure want to delete the item?",
  similar_item_name_already_exists: "Similar item name already exists. Would you like to continue?",
  are_you_sure_you_want_to_restore_the_item: "Are you sure want to restore the item?",
  please_enter_valid_value: "Please enter valid value",
  please_enter_valid_name: "Please enter valid name",
  please_enter_valid_email: "Please enter valid email",
  notes: "Notes",
  write_here_something: "Write something here",
  please_select_decimal_separator: "Please select decimal separator",
  decimal_seperator: "Decimal Separator",
  sales_by_item: "Sales by Item",
  last_login: "Last Login",
  send_employee_invitation_email: "Send invitation email",
  send_set_password_link_to_employee_email: "Send set password link to employee email?",
  waiting_for_employee_to_log_in: "Waiting for employee to log in",
  payment: "PAYMENT",
  cashier: "Cashier",
  subtotal: "Subtotal",
  due_amount: "Due Amount",
  change: "Change",
  shift_report: "Shift Report",
  shift_opened: "Shift Opened",
  shift_closed: "Shift Closed",
  cash_drawer: "Cash Drawer",
  starting_cash: "Starting Cash",
  cash_payments: "Cash Payments",
  cash_refunds: "Cash Refunds",
  paid_in: "Paid In",
  paid_out: "Paid Out",
  sales_summary: "Sales Summary",
  gross_sales: "Gross Sales",
  net_sales: "Net Sales",
  total_tendered: "Total Tendered",
  item: "Item",
  item_refunded: "Item Refunded",
  recieved: "Received",
  mark_orders_as_dine_in_takeout_or_for_delivery: "Mark orders as dine in, takeout or for delivery.",
  get_daily_email_on_items_that_are_low_or_out_of_stock: "Get daily email on items that are low or out of stock.",
  warn_cashiers_attempting_to_sell_more_inventory_than_available_in_stock: "Warn cashiers attempting to sell more inventory than available in stock.",
  cheque: "CHEQUE",
  mobile_number: "Mobile Number",
  money_shortcut: "Money Shortcut",
  it_is_a_shortcut_to_input_how_much_your_customer_pay_by_cash: "It is a shortcut to input how much your customer pay by cash.",
  the_item_is_available_for_now: "The item is available for now",
  avaliable_stock: "Available stock",
  low_stock_level: "Low stock level",
  review: "Review",
  release_pos: "Release POS",
  corporate: "CORPORATE",
  personal: "PERSONAL",
  manage_subscription: "Manage Subscription",
  view_account_information: "View Account Information",
  edit_account_information: "Edit Account Information",
  rating_review: "Rating & Review",
  purchase_orders: "Purchase Orders",
  transfer_orders: "Transfer Orders",
  transfer_order: "Transfer Order",
  stock_adjustments: "Stock Adjustments",
  inventory_counts: "Inventory Counts",
  productions: "Productions",
  inventory_history: "Inventory History",
  inventory_valuation: "Inventory Valuation",
  timecards: "Time Cards",
  total_hours_worked: "Total Worked Hours",
  your_free_trial_expires_in: "Your free trial expires in",
  days: "Days",
  active_subscription: "Activate Subscription",
  profile: "Profile",
  setting: "Setting",
  logout: "Logout",
  rows_per_page: "Rows per page",
  first: "First",
  previous: "Previous",
  next: "Next",
  last: "Last",
  select_employee: "Select Employee",
  please_select_employee: "Please select employee",
  please_select_clock_in_date: "Please select clock in date",
  please_select_clock_out_date: "Please select clock out date",
  please_select_clock_in_time: "Please select clock in time",
  please_select_clock_out_time: "Please select clock out time",
  set_pin: "SET PIN",
  when_adding_employees_the_authentication_by_PIN_code_mode_is_enabled_Set_your_own_PIN_to_enter_Tokoin_POS_application: "When adding employees the authentication by PIN code mode is enabled. Set your own PIN to enter TokoPOS application.",
  confirm: "Confirm",
  partial: "Partial",
  full: "Full",
  add_by_category: "Add by Category",
  add_by_supplier: "Add by supplier",
  all_items_will_be_counted: "All items will be counted",
  expected_stock: "Expected Stock",
  save_and_count: "Save & Count",
  add_items_by_category: "Add items by category",
  You_have_no_items_assigned_to_any_category_yet: "You have no items assigned to any category yet",
  add_items_by_supplier: "Add items by supplier",
  You_have_no_items_assigned_to_any_supplier_yet: "You have no items assigned to any supplier yet",
  please_select_supplier: "Please select supplier",
  please_select_title: "Please select title",
  purchase_order_date: "Purchase Order Date",
  expected_arrival_date: "Expected Arrival Date",
  please_select_purchase_date: "Please select purchase date",
  incoming: "Incoming",
  please_enter_valid_quantity: "Please enter valid quantity",
  only_in_stock: "Only QUANTITY in stock",
  this_item_is_out_of_stock: "This item is out of stock",
  additional_cost: "Additional Cost",
  additional_discount: "Additional Discount",
  title: "Title",
  add_additional_cost: "Add an additional cost",
  save_as_draft: "Save as Draft",
  please_enter_title: "Please enter title",
  adjust: "Adjust",
  reason: "Reason",
  received_item: "Received Item",
  inventory_count: "Inventory Count",
  loss: "Loss",
  damage: "Damage",
  please_select_reason: "Please select reason",
  add_stock: "Add Stock",
  remove_stock: "Remove Stock",
  counted_stock: "Counted stock",
  stock_before: "Stock Before",
  stock_after: "Stock After",
  please_enter_valid_stock: "Please enter valid stock",
  please_enter_valid_counted_stock: "Please enter valid counted stock",
  please_enter_valid_remove_stock: "Please enter valid remove stock",
  source_store: "Source Store",
  destination_store: "Destination Store",
  select_source_store: "Select source store",
  select_destination_store: "Select destination store",
  please_select_source_store: "Please select source store",
  please_select_destination_store: "Please select destination store",
  date_of_transfer_order: "Date of Transfer Order",
  please_select_transfer_date: "Please select transfer date",
  source_stock: "Source Stock",
  destination_stock: "Destination Stock",
  create_and_receive: "Create And Receive",
  save_and_receive: "Save And Receive",
  count_item: "Count Item",
  please_select_item: "Please select an item",
  add_to_counted: "Add to counted",
  cost_difference: "Cost Difference",
  counted: "Counted",
  history: "History",
  complete: "Complete",
  pending: "Pending",
  in_progress: "In Progress",
  add_inventory_count: "Add Inventory Count",
  date_created: "Date Created",
  date_completed: "Date Completed",
  all_reasons: "All Reasons",
  sold: "Sold",
  return: "Return",
  receive: "Receive",
  transfer: "Transfer",
  recounted: "Recounted",
  damaged: "Damaged",
  lost: "Lost",
  item_add: "Item Add",
  adjustment: "Adjustment",
  transferred: "Transferred",
  total_inventory_value: "Total Inventory Value",
  total_retail_value: "Total Retail Value",
  potential_profit: "Potential Profit",
  retail_value: "Retail Value",
  inventory_value: "Inventory Value",
  disassembly: "Disassembly",
  add_production: "Add Production",
  add_disassembly: "Add Disassembly",
  production_count: "Production count",
  add_purchase_order: "Add Purchase Order",
  mark_all_received: "Mark all as Received",
  to_receive: "To Receive",
  select_additional_costs_to_apply_to_this_receipt: "Select additional costs to apply to this receipt",
  please_enter_quantity: "Please enter quantity",
  ordered: "Ordered",
  received: "Received",
  add_stock_adjustments: "Add Stock adjustments",
  TRANSIT: "TRANSIT",
  TRANSFERRED: "TRANSFERRED",
  add_transfer_orders: "Add Transfer Orders",
  ordered_by: "Ordered by",
  count_stock: "Count Stock",
  approve: "Approve",
  send: "Send",
  of: "of",
  send_purchase_order_by_email: "Send purchase order by email",
  from: "From",
  to: "To",
  cc: "Cc",
  subject: "Subject",
  message: "Message",
  attachment: "Attachment",
  all_stock_adjustments: "All stock adjustments",
  adjust_by: "Adjust by",
  year: "Years",
  quarter: "Quarters",
  month: "Months",
  week: "Weeks",
  hours: "Hours",
  line: "Line",
  bar: "Bar",
  pie: "Pie",
  sales_by_item_chart: "Sales by Item Chart",
  Top_5_items: "Top 5 Items",
  quantity_sold: "Quantity sold",
  quantity_refunded: "Quantity refunded",
  review_date: "Review Date",
  average_rating: "Average Rating",
  completed: "Completed",
  purchase_date: "Purchase Date",
  please_enter_valid_available_stock: "Please enter valid available stock",
  jubelio_integration: "Jubelio Integration",
  connect_to_jubelio_account: "Connect to Jubelio Account",
  please_login_to_your_jubelio_account: "Please login to jubelio account",
  no_account_yet: "No acccount yet",
  create_an_account: "Create an Account",
  jubelio_account: "Jubelio Account",
  jubelio_sale_id: "Jubelio Sale Id",
  jubelio_sale_name: "Jubelio Sale Name",
  sync_status: "Sync Status",
  all_order: "All Order",
  send_receipt: "Send Receipt",
  related_to: "Related to",
  add_another_address: "Add another address",
  address_label: "Address Label",
  address_label_ex: "ex: Home, Office,...",
  address_detail: "Address Detail",
  province: "Province",
  district: "District",
  village: "Village",
  select_province: "Select Province",
  select_city: "Select City",
  select_district: "Select District",
  select_village: "Select Village",
  delete_address_information: "Delete address information",
  are_you_sure_you_want_to_delete_this_address_information: "Are you sure want to delete this address information?",
  personal_information: "Personal Information",
  address_information: "Address Information",
  make_this_address_default: "Make this address default",
  default_address: "Default address",
  subscription: "Subscription",
  period: "Period",
  end_date: "End Date",
  subscribe: "Subscribe",
  unsubscribe: "Unsubscribe",
  deactivate: "Deactivate",
  apply: "Apply",
  today: "Today",
  yesterday: "Yesterday",
  this_month: "This Month",
  this_year: "This Year",
  last_week: "Last Week",
  last_month: "Last Month",
  no_transfer_orders_found: "No Transfer Orders Found",
  draft: "Draft",
  closed: "Closed",
  owner: "Owner",
  unable_to_synchronize_to_jubelio: "Unable to synchronize to Jubelio",
  sku_cannot_be_found: "item_name's SKU can not be found",
  type_to_search_here: "Type to search here",
  edit_store: "Edit Store",
  edit_pos: "Edit POS",
  edit_menu: "Edit Menu",
  edit_dinning_option: "Edit Product Delivery Option",
  edit_role: "Edit Role",
  time_card: "Time Card",
  add_time_card: "Add Time Card",
  edit_time_card: "Edit Time Card",
  add_kitchen_printer: "Add Kitchen Printer",
  edit_kitchen_printer: "Edit Kitchen Printer",
  edit_tax: "Edit Tax",
  add_modifier: "Add Modifier",
  edit_modifier: "Edit Modifier",
  edit_item: "Edit Item",
  edit_supplier: "Edit Supplier",
  purchase_order: "Purchase Order",
  edit_purchase_order: "Edit Purchase Order",
  purchase_order_details: "Purchase Order Details",
  receive_purchase_order: "Receive Purchase Order",
  add_transfer_order: "Add Transfer Order",
  transfer_order_details: "Transfer Order Details",
  edit_transfer_order: "Edit Transfer Order",
  stock_adjustment: "Stock Adjustment",
  add_stock_adjustment: "Add Stock Adjustment",
  stock_adjustment_details: "Stock Adjustment Details",
  edit_stock_adjustment: "Edit Stock Adjustment",
  add_inventory_counts: "Add Inventory Counts",
  inventory_count_details: "Inventory Count Details",
  edit_inventory_counts: "Edit Inventory Counts",
  production: "Production",
  production_details: "Production Details",
  disassembly_details: "Disassembly Details",
  edit_production: "Edit Production",
  edit_disassembly: "Edit Disassembly",
  review_rating: "Review & Rating",
  sales_by_modifier: "Sales By Modifier",
  error: "Error",
  looks_like_something_went_wrong: "Looks like something went wrong!",
  report: "Report",
  total_amount: "Total Amount",
  data: "Items",
  restore: "Restore",
  delete_suppiler: "Delete Suppliers",
  delete_suppiler_confirm: "Are you sure you want to delete this supplier?",
  no_supplier_found: "No Supplier Found",
  start_time: "Start Time",
  end_time: "End Time",
  active_company: "Active Company",
  default_so_salesman : "Default Salesman for Sales Order",
  default_po_salesman : "Default Salesman for Purchase Order",
  default_location: "Default Location",
  sync_all_sales_to_jubelio: "Synchronize All Sales and Purchase Orders from TokoPOS to Jubelio",
  add_item_to_jubelio: "Add Items from Jubelio",
  item_bundle: "Item Bundle",
  search_product_name_or_sku: "Search Product Name or SKU",
  product_name: "Product Name",
  existed_sku: "Existed SKU",
  item_added: "Item Added",
  list_is_empty: "List is empty",
  delete_category: "Delete Category",
  delete_timecard: "Delete Time Card",
  confirm_delete_timecard: "Are you sure you want to delete the timecard?",
  minutes: "minutes",
  please_enter_to_select: "Press enter to select",
  please_enter_to_remove: "Press enter to remove",
  expected_date_must_not_earlier_than_purchase_date: "Expected date must not be earlier than Purchase Date",
  must_not_earlier_than_clock_time: "Must not be earlier than clock in Time",
  unable_to_sync: "Unable to sync",
  you_do_not_have_access_to_menu: "You do not have access to this menu",
  the_owner_must_signin_to_the_jubelio: "The owner must sign in to the Jubelio account before you can access this menu",
  shipping_address: "Shipping Address",
  product_delivery_option: "Product Delivery Option",
  enable_b2b: "B2B",
  enable_b2b_desc: "Enable buying item(s) from another store(s) under this business account.",
  enable_b2b_buying: "Enable B2B Buying",
  b2b_price: "B2B Price",
  assigned_to: "Assigned to",
  assigned_to_n_store: "Assigned to n_store store",
  assigned_to_all_stores: "Assigned to all stores",
  customer_assigned_to: "Assigned to",
  customer_assigned_to_all_stores: "Assigned to all store",
  search_store: "Search store",
  select_all_stores: "Select all stores",
  search_variant: "Search variant",
  select_all_variants: "Select all variants",
  search_store_or_variant_added: "Search store or variant added",
  for_stores_that_not_enabled_b2b_buying: "For stores that DO NOT enable B2B Buying, only Sales Orders will be synchronized",
  for_stores_that_enabled_b2b_buying: "For stores that enable B2B Buying, only Purchase Orders will be synchronized",
  delivery_fee: "Delivery Fee",
  insurance: "Insurance",
  other_cost: "Other Cost",
  filter_by: "Filter by",
  manage_transfer_order: "Manage Transfer Order",
  manage_stores: "Manage Stores",
  access_rights: "Access Rights",
  manage_roles: "Manage roles",
  no_results_found: "No results found",
  create_items: "Create Items",
  manage_items_inventory: "Manage Items and Inventory",
  update: "Update",
  receive_transfer_order: "Receive transfer order",
  are_you_sure_you_want_to_receive_all_items: "Are you sure you want to receive all items?",
  send_transfer_order_by_email: "Send transfer order by email",
  please_select_state: "Please select province",
  please_select_district: "Please select district",
  please_select_city: "Please select city",
  please_select_village: "Please select village",
  account_information: "Account Information",
  business_information: "Business Information",
  select_business_type: "Select Business Type",
  sub_business_type: "Sub Business Type",
  select_sub_business_type: "Select Sub Business Type",
  id_card_number: "ID Card (KTP) Number",
  name_on_id_card: "Name on ID Card (KTP)",
  date_of_birth: "Date of Birth",
  id_card: "ID Card",
  selfie_with_id_card: "Selfie with ID Card",
  bank_information: "Bank Information",
  bank_name: "Bank Name",
  account_holder_name: "Account Holder Name",
  account_number: "Account Number",
  country_language_chosen: "Country & Language Chosen",
  language: "Language",
  destination_store_can_not_be_the_same_as_source_store: "Destination store can not be the same as source store",
  gender: "Gender",
  male: "Male",
  female: "Female",
  business_resources: "Business Resources",
  go: "Go",
  fillter_tags: "Filter Tag",
  selected: "Selected",
  press_enter_to_create_new_tag: "Press enter to create a tag",
  customer_sharing: "Customers Data Sharing",
  customer_sharing_desc: "Allow sharing customers data between store(s) under this business account.",
  this_customer_is_not_assigned_to_any_store: "This customer is not assigned to any store. Do you want to continue?",
  no_orders_found: "No Orders Found",
  no_stock_adjustment_found: "No Stock Adjustment Found",
  no_inventory_count_found: "No Inventory Counts Found",
  no_inventory_valuation_found: "No Valuation Items Found",
  no_inventory_history_found: "No Inventory History Found",
  account_need_verify_to_do_action: "Your account is still being verified by our team. You can only do this action after your account status is verified.",
  duplicated_category: "Duplicate Category",
  image_ratio_1_3_validator: "Please upload image with ratio 3:1",
  whats_app_number: "WhatsApp Number",
  whats_app_desc: "This number will be used on the WhatsApp chat button for your online storefront catalog.",
  working_hours_information: "Work Hours Information",
  working_hours_holder: "E.g., Monday: 09.00 - 18.00",
  delivery_information: "Delivery Information",
  delivery_holder: "E.g., We will send your order 1 day after we receive the payment.",
  payment_information: "Payment Information",
  payment_holder: "E.g., Our admin will contact you through WhatsApp for the total payment.",
  other_note: "Other Note",
  other_note_holder: "E.g., If you want to use bubble wrap, please include it on the order note.",
  product_catalog: "Product Catalog",
  add_or_remove_product: "Add/Remove Product",
  add_product: "Add Product",
  remove_product: "Remove Product",
  promotion_links: "Promotion Links",
  promotion_link_desc: "These links will be shown on your Profile page.",
  enter_title: "Enter Title",
  add_new_link: "Add New Link",
  online_storefront: "Online Storefront",
  online_storefront_desc: "Enable online storefront features for your business account.",
  online_storefront_status: "Storefront Status",
  online_storefront_open_store: "Open Store",
  online_storefront_store_information: "Store Information",
  online_storefront_image: "Store Image",
  online_storefront_domain: "Store Domain",
  online_storefront_domain_desc: "This link will be used by customers to buy your products online.",
  online_storefront_domain_holder: "Ex: jubelio",
  online_storefront_domain_confirm: "The domain link will be permanent and you will not be able to change it. Do you want to continue?",
  online_storefront_domain_error: "This store name isn’t available, please enter another name.",
  manage_online_storefront: "Manage online storefront",
  manage_online_storefront_cap: "Manage Online Storefront",
  access_all_processed_orders: "Access all processed orders",
  please_enter_domain_link: "Please enter domain link",
  required_to_fill: "Required to fill",
  no_promotion_link_available: "No promotion link available",
  link_is_not_valid: "Link is not valid",
  no_product_found: "No products found",
  successful_saved: "Successful Saved",
  store_open_now: "Your store is now open",
  store_close_now: "Your store is now close",
  product_catalog_empty_alert: "Your product catalog is empty. Do you want to continue saving your online storefront with no product?",
  product_catalog_remove_last_alert: 'If you remove this product, your product catalog will be empty. Do you want to proceed?',
  unsaved_change: "Unsaved Changes",
  unsaved_change_message: "Are you sure you want to continue without saving?",
  process_online_storefront_order: "Process online storefront orders",
  help: 'Help',
  hello: 'Hello',
  need_some_help: 'Need some help?',
  feel_free_contact: 'Feel free to reach us anytime you need help from one of our channels below',
  call: 'Call',
  whats_app_message: 'WhatsApp Message',
  help_any_time: 'Our {} are ready to help you at anytime.',
  page_missing: 'OOPS! PAGE MISSING',
  page_missing_content: 'WE ARE SORRY BUT THE PAGE YOU REQUESTED CANNOT BE FOUND.',
  back_to_home: 'Back to Home',
  continue: "Continue",
  cancel: "Cancel",
  workspace: "Workspace",
  username: "Username",
  login_page: LoginPage,
  set_new_signin_password: 'Set New Sign In Password',
  recommend_change_password: 'We recommend you set a new password for the next sign in. In case you forget your password, you have to ask your business account owner to change it.',
  initial_password: 'Initial Password',
  update_password: 'Update Password',
  initial_password_validation: 'Password should be at least',
  characters: 'characters',
  automatically_assigned_to_all_stores: 'Automatically assigned to all stores',
  automatically_assigned_to_all_stores_desc: 'This employee will automatically assigned to all of your stores, including new store. Do you want to continue?',
  e_wallet: 'E-WALLET',
  e_wallet_mobile_phone_number: 'E-Wallet Mobile Number',
  payment_note: "Payment Note",
  payment_name: "Payment Name",
  active: 'Active',
  rejected: 'Rejected',
  audit_log: 'Audit Log',
  object: 'Object',
  before_changes: 'Before Changes',
  after_changes: 'After Changes',
  see_detail: 'See Detail',
  changes_detail: 'Changes Detail',
  no_audit_log_found: 'No Audit Log Found',
  all_objects: "All Objects",
  different: "Different",
  field: "Field",
  item_inventory: "Item - Inventory",
  recommended_product: "Recommended Product",
  recommend: "Recommend",
  remove: "Remove",
  recommended_items: "Recommended Items",
  you_are_not_add_recommend_items: "You have not added recommended items. Start by clicking on “RECOMMEND” button in the list items below.",
  you_can_only_add_up_to_10_product: "You can only add up to 10 products as recommended items",
  reset: "Reset",
  zoom_in: "Zoom In",
  zoom_out: "Zoom Out",
  rotate_plus_90: "Rotate +90deg",
  rotate_minus_90: "Rotate -90deg",
  object_name: "Object Name",
  deactivate_payment_type: "If you disable this payment method, your store will not be able to accept online transactions. Do you want to disable it?",
  sobat_store: "Sobat Store",
  sobat_catalog_price: "Sobat Catalog Price",
  sobat_catalog_description: "Sobat Catalog Description",


}
